import { AsyncPipe } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Observable } from "rxjs";
import { filter, take, tap } from "rxjs/operators";

import { SvgIconComponent } from "@hermes/aphrodite-svg";
import { FooterItemsState, ShellFacade } from "@hermes/domains-shell-states-shell-state";

import {
    FeatureFlagFacade,
    FOOTER_NEWSLETTER_REMOVAL,
} from "@hermes/hermes-web-states-flipper-state";

import { UserAgentPlatformService } from "@hermes/utils-generic-services-user-agent-platform";

import { FooterColumnsDeprecatedComponent } from "../footer-columns-deprecated/footer-columns-deprecated.component";
import { FooterCopyrightDeprecatedComponent } from "../footer-copyright-deprecated/footer-copyright-deprecated.component";
import { FooterCountrySelectorButtonDeprecatedComponent } from "../footer-country-selector-button-deprecated/footer-country-selector-button-deprecated.component";
import { FooterHereToHelpDeprecatedComponent } from "../footer-here-to-help-deprecated/footer-here-to-help-deprecated.component";
import { FooterLegalLinksDeprecatedComponent } from "../footer-legal-links-deprecated/footer-legal-links-deprecated.component";
import { FooterNewsletterDeprecatedComponent } from "../footer-newsletter-deprecated/footer-newsletter-deprecated.component";
import { FooterSocialNetworksDeprecatedComponent } from "../footer-social-networks-deprecated/footer-social-networks.component";

@Component({
    selector: "h-footer-deprecated",
    imports: [
        FooterColumnsDeprecatedComponent,
        FooterHereToHelpDeprecatedComponent,
        FooterNewsletterDeprecatedComponent,
        FooterSocialNetworksDeprecatedComponent,
        FooterCountrySelectorButtonDeprecatedComponent,
        SvgIconComponent,
        FooterLegalLinksDeprecatedComponent,
        FooterCopyrightDeprecatedComponent,
        AsyncPipe,
    ],
    templateUrl: "./footer-deprecated.component.html",
    styleUrls: ["./footer-deprecated.component.scss"],
})
export class FooterDeprecatedComponent {
    private shellFacade = inject(ShellFacade);
    private featureFlagFacade = inject(FeatureFlagFacade);

    @Input()
    public hasLightCopyright!: boolean;

    public readonly isMobile = inject(UserAgentPlatformService).isMobileSignal;
    public isNewsletterRemove = toSignal(
        this.featureFlagFacade.isActivated(FOOTER_NEWSLETTER_REMOVAL),
        { initialValue: false },
    );

    public footerItems$: Observable<FooterItemsState> =
        this.shellFacade.footerItems$.pipe(
            tap((data) => {
                if (!data) {
                    this.shellFacade.fetchFooterItems();
                }
            }),
            filter((footerItems) => footerItems !== undefined),
            take(1),
        );
}
